import axios from "axios";

export const ApiViaCep = axios.create({
  baseURL: process.env.REACT_APP_VIACEP_URL,
  headers: {
    "Content-type": "application/json; charset=UTF-8",
  },
});
